export default {
  title: 'Microaudience Composition (%)',
  infoDialog: 'Select periods for top 5 demographic micro-audiences KPI contribution comparison',
  selectWave: 'Select Wave',
  projectedWave: 'Projected Wave'
}
